import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import { UserState } from "../../../types-interfaces/interfaces";
import { ISession } from "../../../components/types/user";
import { ThunkDispatch as Dispatch } from "redux-thunk";
import { checkAuth } from "../../../services/api-ssrr/CollectionManagerAPIClient";
import { getAccessToken } from "../../../services/msal/msal";

const initialState: UserState = {
  email: "",
  name: "",
  token: "",
  profiles: [],
  users: [],
  currentSession: {
    user: undefined,
    isAuthenticated: false,
    accessToken: undefined,
    permissions: [],
  },
  expiredToken: {
    status: false,
    checkDate: ''
  },
  loginInProcess: false
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.profiles = action.payload.profiles;
      //Probablemente sin uso
      state.token = action.payload.token;
      state.users = action.payload.users;
      state.currentSession = action.payload.currentSession;
    },
    setUserValue: (
      state,
      action: PayloadAction<{ name: string; value: string }>
    ) => {
      switch (action.payload.name) {
        case "email":
          state.email = action.payload.value;
          break;
        case "name":
          state.name = action.payload.value;
          break;
        case "token":
          state.token = action.payload.value;
          break;
      }
    },
    setUserSession: (state, action: PayloadAction<ISession>) => {
      state.currentSession = action.payload;
    },
    setExpiredToken: (state, action) => {
      state.expiredToken = action.payload;
    },
    setLoginInProcess: (state, action) => {
      state.loginInProcess = action.payload;
    }
  },
});

export const { setUser, setUserValue, setUserSession, setExpiredToken, setLoginInProcess } = userSlice.actions;
export const selectUser = (state: RootState) => state.userState;
export default userSlice.reducer;

export function refreshAccount(account: any, setSession: any) {
  return async (dispatch: Dispatch<any, any, any>) =>  {
    try {
      var session: ISession = {
        isAuthenticated: true,
        user: {
          username: account?.name,
          email: account?.username,
        },
        accessToken: "",
        permissions: [],
      };
      
      const token = await getAccessToken().then((data: any) => data.idToken);
      session.accessToken = token;

      setSession(session);
    } catch (error) {
      dispatch(setExpiredToken({ status: true, checkDate: new Date().toLocaleString() }));
      var expiredSession: ISession = {
        user: undefined,
        isAuthenticated: false,
        accessToken: undefined,
        permissions: []
      };
      dispatch(setUserSession(expiredSession));
    }
  };
}

export function fetchCheckAuth(userState: UserState) {
  return async (dispatch: Dispatch<any, any, any>) => {
      try {
          const response = await checkAuth(userState.currentSession?.accessToken!, userState.currentSession?.user?.email!);
          const expiredToken = response === 401 ? true : false;
          
          dispatch(setExpiredToken({ status: expiredToken, checkDate: new Date().toLocaleString() }));
          if (expiredToken) {
            var session: ISession = {
              user: undefined,
              isAuthenticated: false,
              accessToken: undefined,
              permissions: []
            };
            dispatch(setUserSession(session));
          }
      } catch (error) {
          console.log(error);
      }
  }
}